module.exports = __webpack_public_path__ + "static/img/__7913.b957e23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__7913.jpg
// module id = b5RD
// module chunks = 0